import React, { useEffect, useState } from 'react';

import i18n from 'i18n-react';
import { HashLink as Link } from 'react-router-hash-link';
import { cssTransition,toast, ToastContainer } from 'react-toastify';

import RewardMenu from 'components/RewardMenu';

import APIHandler from 'config/APIHandler';
import StorageHandler from 'config/StorageHandler';

import testData from 'views/BookingRewardsView/testdata.json';

import { baseAppId,storageKeys } from 'settings';

const getProducts = async (callback) => {
  try {
    callback({ testData });
  } catch (error) {
    // console.log(error);
  }
};

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

const BookingRewardsView = () => {
  const [products, setProducts] = useState([]);
  const [points, setPoints] = useState({});
  const [search, setSearch] = useState([]);

  useEffect(() => {
    if (products.length === 0) {
      getProducts((e) => {
        setProducts(e.testData);
        setSearch(e.testData);
      });
    }
    if (!(points.total >= 0)) {
      StorageHandler.load(storageKeys.accessToken).then((token) => {
        const startDate = '2021-07-21';
        const endDate = '2022-12-21';
        APIHandler.getPoints(baseAppId, startDate, endDate, token).then((res) => {
          setPoints(res.total);
        });
      });
    }
  });

  const onClick = (event) => {
    event.preventDefault();
    const id = event.target.value - 1;
    const product = search[id];

    if (points.confirmed < product.points) {
      const pointShort = `need: ${product.points} points, have: ${points.confirmed} points`;
      toast.error(pointShort, {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      const bought = `bought ${product.title} for ${product.points} points`;
      toast.success(bought, {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <div className="contentContainer BookingForm">
      <div className="header">
        <Link to="/main">
          <img
            src="https://s3.amazonaws.com/developertool/1441/1686831353-sociallogo120.png"
            alt="Logo"
            className="logo"
          />
        </Link>
        <h3>{i18n.translate('rewards.bookingRewardsView.title')}</h3>
      </div>
      <hr />
      <div className="tableNavHead">
        <p>
          {'Available Points: '}
          {points.confirmed}
        </p>
        <p>
          {'Pending Points: '}
          {points.pending}
        </p>
      </div>
      <hr />

      <div className="product-content">
        <div className="products">
          {search.map((e) => (
            <div className="card" key={e.id}>
              <span className="points">
                {'points : '}
                {e.points.toLocaleString()}
              </span>
              <div className="bottom">
                <img src={e.image} alt={e.title} data-type="image" data-fancybox={e.id} data-src={e.image} />
                <h2>{e.title}</h2>
                <span>{e.category}</span>
                <button type='button' className="btn" value={e.id} onClick={onClick}>
                  {'REDEEM'}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <ToastContainer draggablePercent={70} />
      <RewardMenu />
    </div>
  );
};

export default BookingRewardsView;